module.exports = __webpack_public_path__ + "img/demo.cfd1dd04.jpg";